import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { hideTarget: String, showTarget: String }

  connect() {
    this.element.addEventListener("click", this.toggle.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("click", this.toggle.bind(this));
  }

  toggle() {
    // Hide all elements with hideClass
    document.querySelectorAll(this.hideTargetValue).forEach(el => {
      el.classList.add("d-none")
      el.querySelectorAll('input, select, textarea').forEach(formInput => {
        formInput.disabled = true;
      });
    })

    // Show all elements with showClass
    document.querySelectorAll(this.showTargetValue).forEach(el => {
      el.classList.remove("d-none")
      el.querySelectorAll('input, select, textarea').forEach(formInput => {
        formInput.disabled = false;
      });
    })
  }
}
